import moment from "moment";
import React from "react";
import * as RB from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";

function View(props) {
  const { rowData } = props;

  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  queryParams.delete("id");

  const handleBackClick = () => {
    queryParams.delete("id");
    if (props.myOthers) {
      navigate("marketing/my-others/");
    }
  };

  return (
    <>
      <div className="section-body">
        <RB.Card className="card shadow">
          <RB.Card.Header className="border-0">
            <h5>View Others Details</h5>
            <div className="card-header-action">
              <Link
                className="btn btn-underline me-2"
                onClick={handleBackClick}
              >
                Back
              </Link>
            </div>
          </RB.Card.Header>
          <RB.Card.Body>
            <>
              <RB.Row className="mb-3">
                {rowData.other_name && (
                  <RB.Col md={4}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Other Name
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.other_name || "-"}
                    </p>
                  </RB.Col>
                )}

                {rowData.state_name && (
                  <RB.Col md={4}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      State
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.state_name || "-"}
                    </p>
                  </RB.Col>
                )}

                {rowData.district_name && (
                  <RB.Col md={4}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      District
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.district_name || "-"}
                    </p>
                  </RB.Col>
                )}

                {rowData.city_name && (
                  <RB.Col md={4}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      City
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.city_name || "-"}
                    </p>
                  </RB.Col>
                )}

                {rowData.subject && (
                  <RB.Col md={4}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Subject
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.subject || "-"}
                    </p>
                  </RB.Col>
                )}

                {rowData.subject_detail && (
                  <RB.Col md={4}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Subject Detail
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.subject_detail || "-"}
                    </p>
                  </RB.Col>
                )}

                {rowData.contact_name && (
                  <RB.Col md={4}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Contact Name
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.contact_name || "-"}
                    </p>
                  </RB.Col>
                )}

                {rowData.contact_no && (
                  <RB.Col md={4}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Contact Number
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.contact_no || "-"}
                    </p>
                  </RB.Col>
                )}

                {rowData.total_amt && (
                  <RB.Col md={4}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Total Amount
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      ₹{Number(rowData.total_amt).toFixed(2)}
                    </p>
                  </RB.Col>
                )}

                {Array.isArray(rowData.emp_details) &&
                  rowData.emp_details.length > 0 && (
                    <RB.Col md={12}>
                      <span className="text-uppercase fw-bold small text-body-secondary">
                        Employees
                      </span>
                      <p className="fw-medium text-sm fw-semibold">
                        {rowData.emp_details
                          .map((emp) => emp.full_name)
                          .join(", ")}
                      </p>
                    </RB.Col>
                  )}
              </RB.Row>
            </>

            {!rowData && (
              <p className="text-center fw-bold text-danger">
                No data available to display.
              </p>
            )}
          </RB.Card.Body>
        </RB.Card>
      </div>
    </>
  );
}

export default View;
